module.exports = __webpack_public_path__ + "img/22y.e831c65d.png";